import React from 'react';

import { Link } from 'react-router-dom';
import { 
  FaRegCopyright, 
  FaYoutube 
} from "react-icons/fa6";

import { 
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";

import BlueIllustration from './../../assets/images/static/blueRings.png';
import whiteLogo from './../../assets/images/static/whiteLogo.png';

import BookDemo from './../BookDemo/BookDemo';

import { 
  FooterComponent,
  ImgIllustration,
  RingImg,
  StyledLogo,
  LogoImg,
  AddressSection,
  CallusSection,
  SocialLinks,
  Li,
  Title,
  CopyRights,
} from './styled';

const Footer = () => {
  return (
    <>
    <BookDemo />
    <FooterComponent>
      <ImgIllustration>
        <RingImg
          src={BlueIllustration}
          className='hideonMobile'
        />
      </ImgIllustration>
      <StyledLogo>
        <LogoImg src={whiteLogo} />
      </StyledLogo>
      <AddressSection className='hidden'>
        KPITB, 134 Industrial Estate Hayatabad, 
        <br />
        Peshawar, KPK, Pakistan – 25000
      </AddressSection>
      <CallusSection className='hidden'>
        Call Us:
        <br />
        <Link to="tel:03331184316">0333 1184316</Link>
        <br />
        <Link to="tel:03331184316">0333 1184316</Link>
      </CallusSection>
      <SocialLinks>
        <Li>
          <Link to="https://www.instagram.com/eretailpoint/" target='_blank'>
            <FaInstagram />
          </Link>
        </Li>
        <Li>
          <Link to="https://www.facebook.com/eretailpoint/" target='_blank'>
            <FaFacebookF />
          </Link>
        </Li>
        <Li>
          <Link to="https://twitter.com/EretailPoint" target='_blank'>
            <FaTwitter />
          </Link>
        </Li>
        <Li>
          <Link to="https://www.linkedin.com/company/e-retail-point/about/" target='_blank'>
            <FaLinkedinIn />
          </Link>
        </Li>
        <Li>
          <Link to="https://www.youtube.com/@e-retailpoint5959" target='_blank'>
            <FaYoutube />
          </Link>
        </Li>
      </SocialLinks>
      <Title>Powered by <Link to="https://smsami.com/" target='_blank'>SMSAMI</Link></Title>
      <CopyRights>
        <FaRegCopyright />
        Copyright 2023. E-Retail Point - All Rights Reserved
      </CopyRights>
    </FooterComponent>
    </>
  )
}

export default Footer;
